module.exports = __webpack_public_path__ + "img/help2_mobile.d48a5798.png";